
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable, observable } from 'rxjs';
import { resolve } from 'dns';
import { promise } from 'protractor';
import { catchError } from 'rxjs/operators';
import { CallParams } from 'src/app/model/call-params.model';
import { SaveCallRecordingParams } from 'src/app/model/save-call-recording-params.model';

@Injectable()
export class CommonService {

  callListResponseData = [];
  prsCallListResponseData = [];
  customerResponse = '';
  prsCustomerResponse: any = '';
  interval;
  followupDataSource = [];
  prsFollowupDataSource = [];
  workedCallListData = [];
  userId :any;
  userRole :any;
  roleId :any = localStorage.getItem('roleId');
  refreshTokenCheck: number;
  checkFlag : boolean = true;

  countryCode: string;
  followupResponse: Observable<any>;
  prsCallType = '';
  //customerData = JSON.parse(localStorage.getItem('customerData'));

  startInterval() {
    this.userRole = localStorage.getItem('userRoles');
    let loginTime = JSON.parse(localStorage.getItem('LoginTime'));
    let mint = loginTime + (30 * 60 * 1000);
    this.followupResponse = new Observable((observable) => {
      this.interval = setInterval(() => {
        if (this.userRole == "CRE") {
          this.getFollowUpCallList(this.userId, 'N').subscribe(res => {
            observable.next(res);
          })
        } else if (this.userRole == "Call Center Agent") {
          this.getPRSFollowUpCallList(this.prsCallType, this.roleId, this.userId).subscribe(res => {
            observable.next(res);
          })
        }
      }, (30 * 60 * 1000))
    })
  }
  //   return new Promise((resolve, reject) => {
  //   this.interval = setInterval(()=>{
  //     mint = mint + 1000;
  //     this.getFollowUpCallList(this.userId, 'N').subscribe(res => {
  //       return new Promise((resolve, reject) => {
  //         if(res['responseCode'] == 1 ) {
  //           resolve(res);
  //         } else {
  //           reject("No Data Found");
  //         }
  //       this.followupResponse = res;
  //       })
  //     });
  //   }, mint);
  //   if(this.followupResponse) {
  //     resolve(this.followupResponse);
  //   // } else {
  //   //   reject("Dta not found 2");
  //   }
  // })
  // }

  stopInterval() {
    clearInterval(this.interval);
  }

  public uri: string;
  public trailUri: string;
  constructor(private http: HttpClient) {
    this.uri = environment.baseUrl;
    //this.trailUri = environment.baseUrlTrailing;
  }


  /**
  * Name: signin
  * purpose: To Sign in user
  * @param {string} userId - The username who is signing in
  * @param {string} currentPassword - The currentPassword
  * @param {string} newPassword - The newPassword to update
  * @return {Observable} response.
  */
  updatePassword(userId: string, currentPassword: string, newPassword: string): Observable<object> {
    const requestUrl = this.uri + 'auth/update-password';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        userId: userId,
        oldPassword: currentPassword,
        newPassword: newPassword
      })
    };
    return this.http.get(requestUrl, httpOptions);
  }

  refreshtoken(): Observable<object> {
    const requestUrl = this.uri + 'auth/get-refresh-token';
    const httpOptions = {
      headers: new HttpHeaders({
        userId: this.userId,
        medium : 'web'
      }),
    };
    return this.http.get(requestUrl, httpOptions);
  }

  /**
  * Name: getDetails
  * purpose: To get uam search data
  * @param {string} userId - The username who is signing in
  * @param {string} searchUserId - The search user name
  * @return {Observable} response.
  */
  getDetails(userId: string, searchUserId: string): Observable<object> {
    const requestUrl = this.uri + 'auth/getUAMSearchUser';
    const httpOptions = {
      headers: new HttpHeaders({
        userId: userId,
        searchUserId: searchUserId
      })
    };
    return this.http.get(requestUrl, httpOptions);
  }

  /**
  * Name: getDefaultDropDown
  * purpose: To get uam Default DropDown
  * @param {string} userId - The username who is signing in
  * @return {Observable} response.
  */
  getDefaultDropDown(userId: string): Observable<object> {
    const requestUrl = this.uri + 'auth/getUAMDefaultDropDownData';
    const httpOptions = {
      headers: new HttpHeaders({
        userId: userId,
      })
    };
    return this.http.get(requestUrl, httpOptions);
  }

  /**
  * Name: getWorkshop
  * purpose: To get uam Workshop
  * @param {string} userId - The username who is signing in
  * @param {string} region - region
  * @param {string} dealerCompany - dealerCompany
  * @return {Observable} response.
  */
  getWorkshop(userId: string, region: string, dealerCompany: string): Observable<object> {
    const requestUrl = this.uri + 'auth/getUAMWorkShop';
    const httpOptions = {
      headers: new HttpHeaders({
        userId: userId,
        region: region,
        dealerCompany: dealerCompany
      })
    };
    return this.http.get(requestUrl, httpOptions);
  }

  /**
  * Name: getDealerCompany
  * purpose: To get uam dealer company
  * @param {string} userId - The username who is signing in
  * @param {string} selectedRegion - region
  * @return {Observable} response.
  */
  getDealerCompany(userId: string, selectedRegion: string): Observable<object> {
    const requestUrl = this.uri + 'auth/getUAMSearchDealerCompany';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        userId: userId,
        region: selectedRegion
      })
    };
    return this.http.get(requestUrl, httpOptions);
  }

  /**
  * Name: getExportExcel
  * purpose: To export report as excel
  * @return {Observable} response binary data object.
  */
  getExportExcel(): Observable<any> {
    let request = this.uri + 'auth/getUAMExcel';
    return this.http.get(request, { responseType: 'blob' as 'blob' });
  }

  /**
  * Name: saveUserData
  * purpose: To save uam customer details and response
  * @param {object} userData - uam customer details
  * @return {Observable} response flag and status.
  */
  saveUserData(userData: any): Observable<object> {
    const request = this.uri + 'auth/saveUserData';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    return this.http.post(request, userData, httpOptions);
  }

  /**
  * Name: signin
  * purpose: To Sign in user
  * @param {string} username - The username who is signing in
  * @param {string} password - The password to signin
  * @return {Observable} response if the user is authenticated.
  */
  signin(username: string, password: string): Observable<object> {
    const requestUrl = this.uri + 'auth/login';
    const request = {
      userId: username,
      password: password
    }
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        medium : 'web'
      })
    };
    return this.http.post(requestUrl, request, httpOptions);
  }

  /**Name: updatePhoneNumber
    * purpose: To user update phone number
    * @param {string} userId - The username who is signing in
    * @param {string} phoneNumber - update phoneNumber
    * @return {Observable} response if the user is authenticated.
  */
  updatePhoneNumber(userId: string, phoneNumber: string): Observable<object> {
    const requestUrl = this.uri + 'auth/update/contact';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        medium: 'web',
        userId: userId,
        contact: phoneNumber
      })
    };
    return this.http.put(requestUrl, {}, httpOptions);
  }

    /**Name: changePhoneNumberAfterLogin
    * purpose: To Sign in user update phone number
    * @param {string} userId - The username who is signing in
    * @param {string} phoneNumber - updated phoneNumber
    * @return {Observable} response if the user is authenticated.
  */
    changePhoneNumberAfterLogin(userId: string, phoneNumber: string): Observable<object> {
      const requestUrl = this.uri + 'auth/logged-in-user/update-contact';
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          medium: 'web',
          userId: userId,
          contactToUpdate: phoneNumber
        })
      };
      return this.http.put(requestUrl, {}, httpOptions);
    }

  /**Name: sendOTP
    * purpose: To send the otp
    * @param {string} userId - The username who is signing in
    * @return {Observable} response if the user is authenticated.
  */
  sendOTP(userId: string): Observable<object> {
    const requestUrl = this.uri + 'auth/send/otp';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        medium: 'web',
        userId: userId
      })
    };
    return this.http.post(requestUrl, {}, httpOptions);
  }

  /**Name: verifyOTP
    * purpose: To verify the otp
    * @param {string} userId - The username who is signing in
    * @return {Observable} response if the user is authenticated.
  */
  verifyOTP(userId: string, roleId: string, otp: string, countryCode: string): Observable<object> {
    const requestUrl = this.uri + 'auth/validate-otp';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        medium: 'web',
        userId: userId,
        roleId: roleId,
        otp: otp,
        countryCode: countryCode,
      })
    };
    return this.http.post(requestUrl, {}, httpOptions);
  }

  /**
  * Name: getUserDetails
  * purpose: To get sign in user data
  * @param {string} userId - The userId who is signing in
  * @return {Observable} response user info
  */
  getUserDetails(userId: string, roleId: string): Observable<object> {
    const requestUrl = this.uri + 'auth/getUserDetails';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        userId: userId,
        roleId: roleId
      })
    };
    return this.http.get(requestUrl, httpOptions);
  }

  /**
  * Name: getWorkshopDetails
  * purpose: To get workshop details
  * @param {string} userId - The userId who is signing in
  * @return {Observable} response workshop list
  */
  getWorkshopDetails(userId: string): Observable<object> {
    const requestUrl = this.uri + 'auth/getWorkshopDetails';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        userId: userId
      })
    };
    return this.http.get(requestUrl, httpOptions);
  }

  /**
  * Name: customercallList
  * purpose: To get customer list
  * @param {string} dealerCode - dealer code
  * @param {string} flag - type of call status to fatch customer list
  * @return {Observable} response customer list.
  */
  customercallList(dealerCode: string, flag: string): Observable<object> {
    const request = this.uri + 'callList/customercallList';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        dealerCode: dealerCode,
        listType: flag,
        countryCode: this.countryCode
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: generatetoken
  * purpose: To generate token
  * @param {string} userID - userid for who we are generating token
  * @return {Observable} response token.
  */
  generatetoken(userID: string): Observable<object> {
    const request = this.uri + 'api/generatetoken';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        userID: userID
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: updateNumber
  * purpose: To set customer number status
  * @param {string} number - customer number
  * @param {string} contactNoOld - customer number
  * @param {string} type - customer number type
  * @param {string} custId - customer id
  * @param {string} userId - userId id
  * @return {Observable} response status.
  */
  updateNumber(number: string, contactNoOld: string, type: string, custId: string, userId: string, oldName: string, newName: string): Observable<object> {
    const request = this.uri + 'callManagement/update-contact';

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        contactNoNew: number,
        contactNoOld: contactNoOld,
        custId: custId,
        userId: userId,
        isPrimary: type,
        oldDriverName: oldName,
        newDriverName: newName
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: callDetails
  * purpose: To get call list
  * @param {string} creCode - CRE id
  * @param {string} custId - customer id
  * @return {Observable} response status.
  */
  callDetails(creCode: string, custId: string, source: string): Observable<object> {
    const request = this.uri + 'callManagement/fetch-call-Logs';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        creCode: creCode,
        custId: custId,
        source: source
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: callCustomer
  * purpose: To get call list
  * @param {string} userId - userId
  * @param {string} custId - custId
  * @param {string} contactNo - contactNo
  * @param {string} isPrimary - isPrimary
  * @return {Observable} response status.
  */
  callCustomer(creId: string, custId: string, contactNo: string, isPrimary: string, source: string): Observable<object> {
    const request = this.uri + 'callManagement/send-notification';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        creId: creId,
        custId: custId,
        custNo: contactNo,
        custType: isPrimary,
        source: source
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
   * Name: downloadAudio
   * purpose: To get call list
   * @param {string} bucketName - bucketName
   * @param {string} fileName - fileName we want to hear
   * @return {Observable} response blob file.
   */
  downloadAudio(bucketName: string, fileName: string, source: string): Observable<object> {
    const request = this.uri + 'callManagement/download-audio?bucketName=' + bucketName + '&file=' + fileName + '&source=' + source;
    return this.http.get(request, { responseType: "blob", observe: 'response' });
  }

  /**
  * Name: callListinfo
  * purpose: To get call list counts
  * @param {string} dealerCode - dealer code
  * @return {Observable} response call count and list info.
  */
  callListinfo(dealerCode: string): Observable<object> {
    const request = this.uri + 'callList/callListinfo';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        dealerCode: dealerCode,
        countryCode: this.countryCode
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: convertDateToString
  * purpose: To get convert date to string
  * @param {date} realDate - date to be changed
  * @return {string} date in string conversion.
  */
  convertDateToString(realDate: Date): string {
    let date = realDate.getDate();
    let month = realDate.getMonth() + 1;
    let year = realDate.getFullYear();
    return year + "-" + month + "-" + date;
  }

  /**
  * Name: customer360
  * purpose: To get customer details
  * @param {string} customerID - customer id whom details to be get
  * @param {string} dealerCode - login dealer's code
  * @return {Observable} response customer details.
  */
  customer360(customerID: string, dealerCode: string): Observable<object> {
    const request = this.uri + 'customer360/customer360';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        customerID: customerID,
        dealerCode: dealerCode
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: history
  * purpose: To get history details for VECHILE
  * @param {string} chassisNo - chassisNo of VECHILE
  * @return {Observable} response VECHILE history details.
  */
  history(chassisNo: string): Observable<object> {
    const request = this.uri + 'customer360/getservicehistory';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        vin: chassisNo
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: kpiCall
  * purpose: To get kpi-call details
  * @param {string} userId - cre userid
  * @param {string} from - start date
  * @param {string} to - end date
  * @return {Observable} response kpi list.
  */
  kpiCall(userId: string, from: string, to: string): Observable<object> {
    const request = this.uri + 'reports/getcrereport';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        userId: userId,
        fromDate: from,
        toDate: to
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: dataGrid
  * purpose: To get dataGrid details
  * @param {string} userId - cre userid
  * @param {string} roleId - roleid
  * @param {string} startDate - start date
  * @param {string} endDate - end date
  * @param {string} workshopFilter - workshop code
  * @return {Observable} response kpi list.
  */
  dataGrid(userId: string, roleId: string, startDate: string, endDate: string, workshopFilter: string, reportType: string): Observable<object> {
    const request = this.uri + 'reports/getDataGrid';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        userId: userId,
        roleId: roleId,
        startDate: startDate,
        endDate: endDate,
        workshopFilter: workshopFilter,
        reportType: reportType,
        countryCode: this.countryCode
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
    * Name: workshopFilter
    * purpose: To get workshopFilter details
    * @param {string} userId - cre userid
    * @param {string} roleId - cre roleid
    * @return {Observable} response kpi list.
    */
  workshopFilter(userId: string, roleId: string): Observable<object> {
    const request = this.uri + 'reports/workshopFilter';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        userId: userId,
        roleId: roleId
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: getcrereportexcel
  * purpose: To export report as excel
  * @param {string} fileType - type of file-fresh or all data
  * @param {string} from - start date
  * @param {string} to - end date
  * @param {string} userId creid
  * @return {Observable} response binary data object.
  */
  getcrereportexcel(fileType: string, from: string, to: string, userId: string): Observable<any> {
    let request = this.uri + 'reports/getcrereportexcel';
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      userId: userId,
      fromDate: from,
      toDate: to,
      fileType: fileType
    });
    return this.http.get(request, { headers, responseType: 'blob' as 'blob' });
  }

  /**
  * Name: getprocessreport
  * purpose: To export report as excel
  * @param {string} from - start date
  * @param {string} to - end date
  * @param {string} userId creid
  * @param {string} roleId - cre roleId
  * @param {string} workshopCode - WorkshopCode
  * @return {Observable} response binary data object.
  */
  getprocessreport(from: string, to: string, userId: string, roleId: string, workshopCode: string): Observable<any> {
    let request = this.uri + 'reports/getprocessreport';
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      userId: userId,
      roleId: roleId,
      fromDate: from,
      toDate: to,
      workshopFilter: workshopCode,
      countryCode: this.countryCode
    });
    return this.http.get(request, { headers, responseType: 'blob' as 'blob' });
  }

  /**
  * Name: callreminder
  * purpose: To scheduled call reminder
  * @param {string} dealerCode - dealer Code
  * @return {Observable} response flag and status.
  */
  callreminder(dealerCode: string): Observable<object> {
    const request = this.uri + 'callList/callreminder';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        dealerCode: dealerCode
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: savedata
  *
  * purpose: To save customer details and response
  * @param {object} custData - customer details
  * @return {Observable} response flag and status.
  */
  savedata(custData: any): Observable<object> {
    const request = this.uri + 'customer360/savedata';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        countryCode: this.countryCode,
      })
    };
    return this.http.post(request, custData, httpOptions);
  }

  /**
  * Name: getDropdownData
  * purpose: To get dropdown data for customer response
  * @param {number} callType - type of response
  * @return {Observable} response data object for response dropdown.
  */
  getDropdownData(callType: number): Observable<object> {
    const request = this.uri + 'customer360/customeresponse';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        callType: callType && callType.toString(),
        countryCode: this.countryCode
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: getUsers
  * purpose: To search customer
  * @param {string} searchText - customer details
  * @param {string} type - type of input
  * @return {Observable} response data object for response auto dropdown.
  */
  getCustomers(searchText: string, type: string, userId: string): Observable<object> {
    const request = this.uri + 'inboundCall/search-customer';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        value: searchText,
        flag: type,
        userId: userId
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: getChassis
  * purpose: To get dropdown data for customer response
  * @param {string} searchText - customer details
  * @return {Observable} response data object for response auto dropdown.
  */
  getChassis(searchText: string): Observable<object> {
    const request = this.uri + 'inboundCall/get-chassic-no';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        number: searchText,
        countryCode:this.countryCode
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: searchContact
  * purpose: To get dropdown data for customer response
  * @param {string} searchText - customer details
  * @return {Observable} response data object for response auto dropdown.
  */
  searchContact(searchText: string): Observable<object> {
    const request = this.uri + 'inboundCall/search-contact';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        number: searchText
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: searchFleet
  * purpose: To get fleet data for selected customer
  * @param {string} customerCode - customer code
  * @return {Observable} response data object for response auto dropdown.
  */
  searchFleet(customerCode: string): Observable<object> {
    const request = this.uri + 'inboundCall/search-fleet';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        custCode: customerCode
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: searchVin
  * purpose: To get dropdown data for customer response
  * @param {string} customerCode - customer code
  * @param {string} creId - creId
  * @return {Observable} response data object for response auto dropdown.
  */
  searchVin(customerCode: string, creId: string, vin: string): Observable<object> {
    const request = this.uri + 'inboundCall/search-vin';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        custCode: customerCode,
        creId: creId,
        vin: vin
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: saveInboundCustomer
  * purpose: To save customer details and response
  * @param {object} custData - customer details
  * @return {Observable} response flag and status.
  */
  saveInboundCustomer(custData: any): Observable<object> {
    const request = this.uri + 'inboundCall/save-customer-details';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        creId: custData.creId,
        custCode: custData.custCode,
        custContactNo: custData.custContactNo,
        fleetContactNo: custData.fleetContactNo,
        fleetName: custData.fleetName,
        userId: custData.userId
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: saveServiceData
  * purpose: To save vehicle service details and response
  * @param {object} serviceData - customer details
  * @return {Observable} response flag and status.
  */
  saveServiceData(serviceData: any): Observable<object> {
    const request = this.uri + 'inboundCall/save-service-data';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        countryCode: this.countryCode
      })
    };
    return this.http.post(request, serviceData, httpOptions);
  }

  /**
  * Name: getcustomerdata
  * purpose: To get customer details
  * @param {string} customerID - customer id whom details to be get
  * @param {string} dealerCode - login dealer's code
  * @return {Observable} response customer details.
  */
  getcustomerdata(customerID: string, dealerCode: string, vin: string): Observable<object> {
    const request = this.uri + 'customer360/getcustomerdata';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        customerID: customerID,
        dealerCode: dealerCode,
        vin: vin,
        countryCode: this.countryCode
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: sendLocationSMS
  * purpose: To send workshop address sms
  * @param {any} data - customer data and workshop data
  * @return {Observable} response.
  */
  sendLocationSMS(data: any): Observable<object> {
    const request = this.uri + 'customer360/sendLocationSMS';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        contactNo: data.contactNo,
        custName: data.custName,
        wSAddress: data.wSAddress,
        wSManager: data.wSManager,
        wSName: data.wSName
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: sendBookingSMS
  * purpose: To send booking sms
  * @param {any} data - customer data and booking data
  * @return {Observable} response.
  */
  sendBookingSMS(data: any): Observable<object> {
    const request = this.uri + 'customer360/sendBookingSMS';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        bkStatus: data.bkStatus,
        bkTime: data.bkTime,
        bkdate: data.bkdate,
        contactNo: data.contactNo,
        custName: data.custName,
        regNo: data.regNo,
        vin: data.vin,
        wSAddress: data.wSAddress,
        wSManager: data.wSManager
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: contactdetail
  * purpose: To get customer contact detail
  * @param {string} customerID - customer id whom details to be get
  * @return {Observable} response customer details.
  */
  contactdetail(customerID: string): Observable<object> {
    const request = this.uri + 'customer360/contactdetail';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        custCode: customerID
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: contactdetail
  * purpose: To get customer contact detail
  * @param {string} creID - customer id whom details to be get
  * @return {Observable} response customer details.
  */
  getCreCallStats(creID: string): Observable<object> {
    const request = this.uri + 'callList/callstats';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        creId: creID,
        countryCode: this.countryCode
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: getDashboardKpiCard
  * purpose: To get DashboardKpiCard
  * @param {any} req - req details to be get
  * @return {Observable} response customer details.
  */
  getDashboardKpiCard(req: any): Observable<object> {
    const requestUrl = this.uri + 'reports/getDashboardKpiCard';
    const request = {
      "userId": req.userId,
      "roleId": req.roleId,
      "creId": req.creId,
      "workshopCode": req.workshopCode,
      "service": req.service,
      "month": req.month,
      "year": req.year
    };

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        countryCode: this.countryCode
      })
    };
    return this.http.post(requestUrl, request, httpOptions);
  }

  /**
  * Name: getDashboardResponseKpi
  * purpose: To get getDashboardResponseKpi
  * @param {any} req - req details to be get
  * @return {Observable} response customer details.
  */
  getDashboardResponseKpi(req: any): Observable<object> {
    const requestUrl = this.uri + 'reports/getDashboardResponseKpi';
    const request = {
      "userId": req.userId,
      "roleId": req.roleId,
      "creId": req.creId,
      "workshopCode": req.workshopCode,
      "service": req.service,
      "startDate": req.startDate,
      "endDate": req.endDate
    };

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        countryCode: this.countryCode
      })
    };
    return this.http.post(requestUrl, request, httpOptions);
  }

  /**
  * Name: getDashboardServiceKpi
  * purpose: To get getDashboardServiceKpi
  * @param {any} req - req details to be get
  * @return {Observable} response customer details.
  */
  getDashboardServiceKpi(req: any): Observable<object> {
    const requestUrl = this.uri + 'reports/getDashboardServiceKpi';
    const request = {
      "userId": req.userId,
      "roleId": req.roleId,
      "creId": req.creId,
      "workshopCode": req.workshopCode,
      "service": req.service,
      "startDate": req.startDate,
      "endDate": req.endDate
    };

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        countryCode: this.countryCode
      })
    };
    return this.http.post(requestUrl, request, httpOptions);
  }

  /**
  * Name: getDashboardKpi
  * purpose: To get getDashboardKpi
  * @param {any} req - req details to be get
  * @return {Observable} response customer details.
  */
  getDashboardKpi(req: any): Observable<object> {
    const requestUrl = this.uri + 'reports/getDashboardKpi';
    const request = {
      "userId": req.userId,
      "roleId": req.roleId,
      "creId": req.creId,
      "workshopCode": req.workshopCode,
      "service": req.service,
      "startDate": req.startDate,
      "endDate": req.endDate
    };

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        countryCode: this.countryCode
      })
    };
    return this.http.post(requestUrl, request, httpOptions);
  }

  /**
  * Name: filterDashboard
  * purpose: To get filter Dashboard
  * @param {any} userInfo - userInfo whom details to be get
  * @return {Observable} response filter details.
  */
  filterDashboard(userInfo: any): Observable<object> {
    const request = this.uri + 'reports/filterDashboard';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        userId: userInfo.userId,
        roleId: userInfo.roleId,
        countryCode: this.countryCode
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: periodFilter
  * purpose: To get periodFilter Dashboard
  * @param {any} userInfo - userInfo whom details to be get
  * @return {Observable} response filter details.
  */
  periodFilter(userInfo: any): Observable<object> {
    const request = this.uri + 'reports/periodFilter';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        userId: userInfo.userId,
        roleId: userInfo.roleId,
        countryCode: this.countryCode
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: getBayVisibility
  * purpose: To get getBayVisibility
  * @param {any} workshopCode - workshopCode whom details to be get
  * @param {any} date - date
  * @return {Observable} response bay Visibility.
  */
  getBayVisibility(workshopCode: any, date: any): Observable<object> {
    const request = this.uri + 'customer360/getBayVisibility';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        workshopCode: workshopCode,
        selectedDate: date
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: getWorkshopBay
  * purpose: To get getWorkshopBay
  * @param {string} creId - creId
  * @return {Observable} response list of bay
  */
  getWorkshopBay(creId: string): Observable<object> {
    const request = this.uri + 'customer360/getWorkshopBay';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        creId: creId
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: getFertPrice
  * purpose: To get getFertPrice
  * @param {any} workshopCode - workshopCode whom details to be get
  * @param {any} fartCode - fartCode
  * @return {Observable} response bay Visibility.
  */
  getFertPrice(workshopCode: any, fartCode: any): Observable<object> {
    const request = this.uri + 'customer360/getFertPrice';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        plant: workshopCode,
        fertCode: fartCode
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: getprscustomerdata
  * purpose: To get customer details
  * @param {string} customerID - customer id whom details to be get
  * @param {string} vin - vehicle vin No
  * @param {string} workshopCode - workshopCode
  * @param {string} callTypeSeq - callTypeSeq
  * @return {Observable} response customer details.
  */
  getprscustomerdata(customerID: string, vin: string, workshopCode: string, callTypeSeq: string, userId: string, roleId: string): Observable<object> {
    const request = this.uri + 'customer360/getprscustomerdata';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        customerID: customerID,
        vin: vin,
        workshopCode: workshopCode,
        callTypeSeq: callTypeSeq,
        userId: userId,
        roleId: roleId,
        countryCode: this.countryCode
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: getprscustomerdata
  * purpose: To get customer details
  * @param {string} customerID - customer id whom details to be get
  * @param {string} vin - vehicle vin No
  * @param {string} workshopCode - workshopCode
  * @param {string} callTypeSeq - callTypeSeq
  * @return {Observable} response customer details.
  */
  getLastServiceRemark(customerID: string, vin: string, workshopCode: string, callTypeSeq: string, userId: string, roleId: string): Observable<object> {
    const request = this.uri + 'customer360/getprslastservice&remarks';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        customerID: customerID,
        vin: vin,
        workshopCode: workshopCode,
        callTypeSeq: callTypeSeq,
        userId: userId,
        roleId: roleId
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: prscontactdetail
  * purpose: To get customer contact detail
  * @param {string} customerID - customer id whom details to be get
  * @return {Observable} response customer details.
  */
  prscontactdetail(customerID: string): Observable<object> {
    const request = this.uri + 'customer360/prs-contact-detail';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        custCode: customerID
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: prscustomercallList
  * purpose: To get customer list
  * @param {string} flag - type of call status to fatch customer list
  * @return {Observable} response customer list.
  */
  prscustomercallList(flag: string, callType: string, userId: string, roleId: string): Observable<object> {
    const request = this.uri + 'callList/prscustomercallList';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        listType: flag,
        callType: callType,
        userId: userId,
        countryCode: this.countryCode,
        roleId: roleId
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: prsCustomeResponse
  * purpose: To get prs Custome Response
  * @param {string} callType  - type of response
  * @return {Observable} response lvl data for response.
  */
  prsCustomeResponse(callType: string): Observable<object> {
    const request = this.uri + 'customer360/prs-customeresponse';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        callType: callType
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: contactdetail
  * purpose: To get customer contact detail
  * @param {string} userId - customer id whom details to be get
  * @return {Observable} response customer details.
  */
  getPrsCallStats(userId: string, roleId: string): Observable<object> {
    const request = this.uri + 'callList/prscallstats';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        userId: userId,
        countryCode: this.countryCode,
        roleId: roleId
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: getPrsFetchQuestions
  * purpose: To get Prs Questions
  * @param {string} category - questions category
  * @return {Observable} response customer details.
  */
  getPrsFetchQuestions(category: string, roleId: string): Observable<object> {
    const request = this.uri + 'customer360/prs-fetch-questions';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        category: category,
        countryCode: this.countryCode,
        roleId: roleId
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: updatePRSNumber
  * purpose: To set customer number status
  * @param {string} number - customer number
  * @param {string} contactNoOld - customer number
  * @param {string} type - customer number type
  * @param {string} custId - customer id
  * @param {string} userId - userId id
  * @return {Observable} response status.
  */
  updatePRSNumber(number: string, contactNoOld: string, type: string, custId: string, userId: string): Observable<object> {
    const request = this.uri + 'customer360/prs-update-contact';

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        contactNoNew: number,
        contactNoOld: contactNoOld,
        custId: custId,
        userId: userId,
        isPrimary: type
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
    * Name: reportTypeFilter
    * purpose: To get reportTypeFilter details
    * @return {Observable} response report type list.
    */
  reportTypeFilter(): Observable<object> {
    const request = this.uri + 'reports/prs-getReportTypes';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
    * Name: prsReportFilter
    * purpose: To get prsReportFilter details
    * @return {Observable} response report filter list.
    */
  prsReportFilter(userId: string, roleId: string): Observable<object> {
    const request = this.uri + 'reports/prs-fetch-regional-vertical-detail';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        userId: userId,
        roleId: roleId,
        countryCode: this.countryCode
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: getPRSDattaGrid
  * purpose: To get data grid details
  * @param {string} region - region
  * @param {string} verticle - verticle
  * * @param {string} workshopCode - WorkshopCode
  * @param {string} from - start date
  * @param {string} to - end date
  * @param {string} reportType - reportType
  * @return {Observable} response binary data object.
  */
  getPRSDattaGrid(region: string, verticle: string, workshopCode: string, from: string, to: string, reportType: string, userId: string, roleId: string): Observable<object> {
    let request = this.uri + 'reports/prs-getDataGrid';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        region: region,
        vertical: verticle,
        workshopCode: workshopCode,
        dateFrom: from,
        dateTo: to,
        reportType: reportType,
        userId: userId,
        roleId: roleId,
        countryCode: this.countryCode
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: getRowDataExcelReport
  * purpose: To get data grid details
  * @param {string} region - region
  * @param {string} verticle - verticle
  * @param {string} dealerCode - dealerCode
  * @param {string} from - start date
  * @param {string} to - end date
  * @param {string} reportType - reportType
  * @return {Observable} response binary data object.
  */
  getRowDataExcelReport(region: string, verticle: string, dealerCode: string, from: string, to: string, reportType: string, userId: string, roleId: string): Observable<any> {
    let request = this.uri + 'reports/getrawreport';
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      region: region,
      vertical: verticle,
      dealerCode: dealerCode,
      fromDate: from,
      toDate: to,
      reportType: reportType,
      userId: userId,
      roleId: roleId,
      countryCode: this.countryCode
    });
    return this.http.get(request, { headers, responseType: 'blob' as 'blob' });
  }

  /**
  * Name: getPRSRowDataExcelReport
  * purpose: To get data grid details
  * @param {string} region - region
  * @param {string} verticle - verticle
  * @param {string} dealerCode - dealerCode
  * @param {string} from - start date
  * @param {string} to - end date
  * @param {string} reportType - reportType
  * @return {Observable} response binary data object.
  */
  getPRSRowDataExcelReport(region: string, verticle: string, dealerCode: string, from: string, to: string, reportType: string, userId: string, roleId: string): Observable<any> {
    let request = this.uri + 'reports/rawDataReportDealerPRS';
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      region: region,
      vertical: verticle,
      dealerCode: dealerCode,
      dateFrom: from,
      dateTo: to,
      reportType: reportType,
      creId: userId,
      roleId: roleId,
      countryCode: this.countryCode
    });
    return this.http.get(request, { headers, responseType: 'blob' as 'blob' });
  }

  /**
  * Name: getExportExcelReport
  * purpose: To get data grid details
  * @param {string} region - region
  * @param {string} verticle - verticle
  * @param {string} dealerCode - dealerCode
  * @param {string} from - start date
  * @param {string} to - end date
  * @param {string} reportType - reportType
  * @return {Observable} response binary data object.
  */
  getExportExcelReport(region: string, verticle: string, dealerCode: string, from: string, to: string, reportType: string, userId: string, roleId: string): Observable<any> {
    let request = this.uri + 'reports/getreport';
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      region: region,
      vertical: verticle,
      dealerCode: dealerCode,
      fromDate: from,
      toDate: to,
      reportType: reportType,
      userId: userId,
      roleId: roleId,
      countryCode: this.countryCode
    });
    return this.http.get(request, { headers, responseType: 'blob' as 'blob' });
  }

  /**
   * Name: getPRSExportExcelReport
   * purpose: To get prs export excel
   * @param region
   * @param vertical
   * @param workshop
   * @param startDate
   * @param endDate
   * @param userId
   * @param roleId
   */
  getPRSExportExcelReport(region: string, vertical: string, workshop: string, startDate: string, endDate: string, userId: string, roleId: string): Observable<any> {
    let request = this.uri + 'reports/detailedDataReportDealerPRS';
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      regionFilter: region,
      verticalFilter: vertical,
      workshopFilter: workshop,
      startDate: startDate,
      endDate: endDate,
      userId: userId,
      roleId: roleId,
      countryCode: this.countryCode
    });
    return this.http.get(request, { headers, responseType: 'blob' as 'blob' });
  }

  /**
  * Name: prsSaveVinFeedback
  * purpose: To save prsSaveVinFeedback
  * @param {any} req - req details to be get
  * @return {Observable} response customer remark flag.
  */
  prsSaveVinFeedback(req: any,complaintId:any,complaintRemarks:any): Observable<object> {
    const requestUrl = this.uri + 'customer360/prs-save-vin-feedback';
    const request = {
      "userId": req.userId,
      "blanketFeedback": req.blanketFeedback || "F,D,N",
      "callTypeInd": req.callTypeInd,
      "custCode": req.customerId,
      "idFeedback": req.idFeedback,
      "complaintId":complaintId,
      "complaintRemarks":complaintRemarks,
      "jobCardNo": req.jobCardNo,
      "vin": req.vin,
      "workshopCode": req.workshopCode,
      "customerType": req.customerType,
      "phoneNo": req.phoneNo,
      "customerName": req.customerName,
    };

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        countryCode: this.countryCode,
        roleId: req.roleId
      })
    };
    return this.http.post(requestUrl, request, httpOptions);
  }

  /**
   * Name: prsFeedbackCheck
   * purpose: To check PRS Feedback
   * @param req
  */
  prsFeedbackCheck(req: any): Observable<object> {
    const requestUrl = this.uri + 'customer360/prsCallCentreFeedbackCheck';
    const request = {
      "customerCode": req.customerId,
      "vin": req.vin,
      "jcNumber": req.jobCardNo,
      "callTypeCode": req.callTypeCode,
      "callTypeSeq": req.callTypeSeq,
      "workshopCode": req.workshopCode,
      "userId": req.userId,
      "dtsCreation": req.dtsCreation,
      "remark": req.remark,
      "blanketFeedback": req.blanketFeedback || "F,D,N",
      "countryCode": this.countryCode,
      "roleId": req.roleId
    };

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }).set('Cache-Control', 'no-cache')
        .set('Pragma', 'no-cache'),
    };

    return this.http.post(requestUrl, request, httpOptions);
  }

  /**
  * Name: prsSaveData
  * purpose: To save prsSaveData
  * @param {any} req - req details to be get
  * @return {Observable} response customer remark flag.
  */
  prsSaveData(req: any): Observable<object> {
    const requestUrl = this.uri + 'customer360/prs-savedata';
    const request = {
      "callEndTime": req.callEndTime,
      "callStartTime": req.callStartTime,
      "callTypeSeq": req.callTypeSeq,
      "customerContactInd": req.customerContactInd,
      "customerId": req.customerId,
      "dealerCode": req.dealerCode,
      "levelData": req.levelData,
      "remark": req.remark,
      "responseForNo": req.responseForNo,
      "serviceDueDate": req.serviceDueDate,
      "userID": req.userID,
      "vin": req.vin,
      "customerType": req.customerType,
      "phoneNo": req.phoneNo,
      "customerName": req.customerName,
      "role":req.role,
      "jobCardNo": req.jobCardNo
    };
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        countryCode:this.countryCode,
        roleId: req.roleId
      })
    };
    return this.http.post(requestUrl, request, httpOptions);
  }

  /**
  * Name: prsSendinfo
  * purpose: To send info sms
  * @param {string} customerName - customer customerName whom details to be get
  * @param {string} number - customer number whom details to be get
  * @return {Observable} response flag.
  */
  prsSendinfo(customerName: string, number: string): Observable<object> {
    const request = this.uri + 'customer360/prs-sendinfo';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        name: customerName,
        number: number
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: prsCallListinfo
  * purpose: To get call list counts
  * @param {string} userId - UserId
  * @return {Observable} response call count and list info.
  */
  prsCallListinfo(userId: string, roleId: string): Observable<object> {
    const request = this.uri + 'callList/prscallListinfo';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        userId: userId,
        countryCode: this.countryCode,
        roleId: roleId
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: forgotPassword
  * purpose: To Forgot Password
  * @param {string} username - The username who is signing in
  * @param {string} email - The email
  * @return {Observable} response if the user is authenticated.
  */
  forgotPassword(username: string, email: string): Observable<object> {
    const requestUrl = this.uri + 'auth/forgot-password';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        userId: username,
        email: email,
        //roleId: this.roleId
      })
    };
    return this.http.get(requestUrl, httpOptions);
  }

  /**
  * Name: amccustomercallList
  * purpose: To get customer list
  * @param {string} flag - type of call status to fatch customer list
  * @return {Observable} response customer list.
  */
  amccustomercallList(flag: string, userId: string, userRoleId: string): Observable<object> {
    const request = this.uri + 'callList/amccustomercallList';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        listType: flag,
        userId: userId,
        userRoleId: userRoleId
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: amcCallListinfo
  * purpose: To get call list counts
  * @param {string} userId - UserId
  * @param {string} userRoleId - userRoleId
  * @return {Observable} response call count and list info.
  */
  amcCallListinfo(userId: string, userRoleId:string): Observable<object> {
    const request = this.uri + 'callList/amccallListinfo';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        userId: userId,
        userRoleId: userRoleId
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: getdealerCode
  * purpose: To get dealer list
  * @param {string} region - type of region to fatch dealer list
  * @return {Observable} response dealer list.
  */
  getdealerCode(region: string): Observable<object> {
    const request = this.uri + 'reports/prs-getDealer';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        region: region
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: getamccustomerdata
  * purpose: To get customer details
  * @param {string} userID - Id of the user
  * @param {string} customerId - customer id whom details to be get
  * @param {string} workshopCode - workshop Code whom details to be get
  * @param {string} callTypeSeq - call Type
  * @return {Observable} response customer details.
  */
  getamccustomerdata(userId: string, customerId: string, workshopCode: string, callTypeSeq: string, userRoleId: string): Observable<object> {
    const request = this.uri + 'customer360/getamccustomerdata';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        creId: userId,
        custCode: customerId,
        workshopCode: workshopCode,
        callTypeSeq: callTypeSeq,
        userRoleId: userRoleId
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: amcContactdetail
  * purpose: To get customer contact detail
  * @param {string} customerID - customer id whom details to be get
  * @return {Observable} response customer details.
  */
  amcContactdetail(customerID: string): Observable<object> {
    const request = this.uri + 'customer360/amc-contact-detail';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        custCode: customerID
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: amcUpdateNumber
  * purpose: To set customer number status
  * @param {string} number - customer number
  * @param {string} contactNoOld - customer number
  * @param {string} type - customer number type
  * @param {string} custId - customer id
  * @param {string} userId - userId id
  * @return {Observable} response status.
  */
  amcUpdateNumber(number: string, contactNoOld: string, type: string, custId: string, userId: string): Observable<object> {
    const request = this.uri + 'customer360/amc-update-contact';

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        contactNoNew: number,
        contactNoOld: contactNoOld,
        custId: custId,
        userId: userId,
        isPrimary: type
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: getBookingFollowupCount
  * purpose: To get Booking & Followup Count
  * @param {string} customerID - customer id whom details to be get
  * @param {string} vin - vehicle vin No
  * @return {Observable} response count.
  */
  getBookingFollowupCount(customerID: string, vin: string, module: string): Observable<object> {
    const request = this.uri + 'customer360/getBookingFollowupCount';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        custCode: customerID,
        vin: vin,
        module: module
      })
    };
    return this.http.get(request, httpOptions);
  }

   /**
  * Name: dataGrid
  * purpose: To get dataGrid details
  * @param {string} userId - cre userid
  * @param {string} roleId - roleid
  * @param {string} startDate - start date
  * @param {string} endDate - end date
  * @param {string} workshopFilter - workshop code
  * @return {Observable} response kpi list.
  */
  getBookingReport(userId: string, roleId: string, startDate: string, endDate: string, workshopFilter: string, reportType: string): Observable<any> {
    let request = this.uri + 'reports/getbookingreport';
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      userId: userId,
      roleId: roleId,
      startDate: startDate,
      endDate: endDate,
      workshopFilter: workshopFilter,
      reportType: reportType,
      countryCode: this.countryCode
    });
    return this.http.get(request, { headers, responseType: 'blob' as 'blob' });
  }

  /**
  * Name: getDataGridExcelReport
  * purpose: To get data grid details
  * @param {string} region - region
  * @param {string} verticle - verticle
  * @param {string} dealerCode - dealerCode
  * @param {string} from - start date
  * @param {string} to - end date
  * @param {string} reportType - reportType
  * @return {Observable} response binary data object.
  */
  getDataGridExcelReport(region: string, verticle: string, dealerCode: string, from: string, to: string, reportType: string, userId: string, roleId: string): Observable<any> {
    let request = this.uri + 'reports/getDataGridExcel';
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      region: region,
      vertical: verticle,
      dealerCode: dealerCode,
      fromDate: from,
      toDate: to,
      reportType: reportType,
      userId: userId,
      roleId: roleId,
      countryCode: this.countryCode
    });
    return this.http.get(request, { headers, responseType: 'blob' as 'blob' });
  }

  /**
  * Name: getRegionValue
  * purpose: To get region details
  * @return {Observable} response region list
  */
  getRegionValue(): Observable<object> {
    const requestUrl = this.uri + 'reports/ms-getWorkshopRegions';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.get(requestUrl, httpOptions);
  }

  /**
  * Name: getLeadExcelReport
  * purpose: To get Lead Excel Report
  * @return {Observable} response binary data object.
  */
  getLeadExcelReport(req: any): Observable<any> {
    const requestURl = this.uri + 'reports/getMSLeadReport';
    const request = {
      "region": req.region,
      "workshopCode": req.workshopCode,
      "serviceTypeCode": req.serviceTypeCode,
      "startDate": req.startDate,
      "endDate": req.endDate,
      "vehicalAge": req.vehicalAge,
      "lostCust": req.lostCust,
      "userId": req.userId
    };
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.post(requestURl, request, { headers, responseType: 'blob' as 'blob' });
  }

  /**
  * Name: getMarketShareReport
  * purpose: To get Market Share Report
  * @param {string} region - region
  * @param {string} workshopCode - workshopCode
  * @param {string} serviceTypeCode - serviceTypeCode
  * @param {string} startDate - start date
  * @param {string} endDate - end date
  * @param {string} vehicalAge - vehicalAge
  * @param {string} lostCust - lostCust
  * @param {string} userId - userId
  * @return {Observable} response binary data object.
  */
  getMarketShareReport(req: any): Observable<any> {
    const requestURl = this.uri + 'reports/fetchMSReportData';
    const request = {
      "region": req.region,
      "workshopCode": req.workshopCode,
      "serviceTypeCode": req.serviceTypeCode,
      "startDate": req.startDate,
      "endDate": req.endDate,
      "vehicalAge": req.vehicalAge,
      "lostCust": req.lostCust,
      "userId": req.userId
    };
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.post(requestURl, request, { headers, responseType: 'blob' as 'blob' });
  }

  /**
  * Name: getMSDealerCode
  * purpose: To get dealer list
  * @param {string} region - type of region to fatch dealer list
  * @return {Observable} response dealer list.
  */
  getMSDealerCode(region: string): Observable<object> {
    const request = this.uri + 'reports/ms-getDealer';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        region: region
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: fetchNotification
  * purpose: To fetch notification detail
  * @param {string} userId - USER id
  * @return {Observable} response status.
  */
  fetchNotification(userId: string): Observable<object> {
    const request = this.uri + 'callManagement/fetchNotification';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        userId: userId
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: updateNotification
  * purpose: To update notification status
  * @param {string} userId - USER id
  * @return {Observable} response status.
  */
  updateNotification(userId: string): Observable<object> {
    const request = this.uri + 'callManagement/updateNotification';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        userId: userId
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: getDashboardReport
  * purpose: To export report as excel
  * @param {string} startDate - start date
  * @param {string} endDate - end date
  * @param {string} userId userId
  * @param {string} roleId - cre roleId
  * @param {string} creid creid
  * @param {string} serviceType serviceType
  * @param {string} workshopFilter - WorkshopCode
  * @return {Observable} response binary data object.
  */
  getDashboardReport(userId: string, roleId: string, creId: string, startDate: string, endDate: string, serviceType: string, workshopFilter: string): Observable<any> {
    let request = this.uri + 'reports/getdashboardreport';
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      userId: userId,
      roleId: roleId,
      creId: creId,
      startDate: startDate,
      endDate: endDate,
      workshopCode: workshopFilter,
      serviceType: serviceType,
	    countryCode: this.countryCode
    });
    return this.http.get(request, { headers, responseType: 'blob' as 'blob' });
  }

  /**
  * Name: getLanguage
  * purpose: To get language details
  * @return {Observable} response language list
  */
  getLanguage(): Observable<object> {
    const requestUrl = this.uri + 'customer360/getlanguage';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.get(requestUrl, httpOptions);
  }

  /**
  * Name: getRowLeadDataExcelReport
  * purpose: To get lead raw data Report
  * @param {string} region - region
  * @param {string} verticle - verticle
  * @param {string} dealerCode - dealerCode
  * @param {string} from - start date
  * @param {string} to - end date
  * @param {string} reportType - reportType
  * @return {Observable} response binary data object.
  */
  getRowLeadDataExcelReport(region: string, verticle: string, dealerCode: string, from: string, to: string, reportType: string, roleId: string): Observable<any> {
    let request = this.uri + 'reports/getleadrawreport';
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      region: region,
      vertical: verticle,
      dealerCode: dealerCode,
      fromDate: from,
      toDate: to,
      reportType: reportType,
      roleId: roleId,
      countryCode: this.countryCode
    });
    return this.http.get(request, { headers, responseType: 'blob' as 'blob' });
  }

  /**
   * Name: getPRSRowLeadDataExcelReport
   * purpose: To get prs lead raw data Report
   * @param region
   * @param vertical
   * @param dealerCode
   * @param from
   * @param to
   * @param reportType
   * @param userId
   * @param roleId
   */
  getPRSRowLeadDataExcelReport(region: string, vertical: string, dealerCode: string, from: string, to: string, reportType: string, userId: string, roleId: string): Observable<any> {
    let request = this.uri + 'reports/leadRawReportDealerPRS';
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      region: region,
      vertical: vertical,
      dealerCode: dealerCode,
      dateFrom: from,
      dateTo: to,
      reportType: reportType,
      creId: userId,
      roleId: roleId,
      countryCode: this.countryCode
    });
    return this.http.get(request, { headers, responseType: 'blob' as 'blob' });
  }

  /**
  * Name: getDropdownData
  * purpose: To get dropdown data for customer response
  * @param {number} callType - type of response
  * @return {Observable} response data object for response dropdown.
  */
  getAMCDropdownData(callType: number): Observable<object> {
    const request = this.uri + 'customer360/amc-customeresponse';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        callType: callType && callType.toString()
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: getAMCDataReport
  * purpose: To export report as excel
  * @param {string} from - start date
  * @param {string} to - end date
  * @param {string} selectedProductType selectedProductType
  * @return {Observable} response binary data object.
  */
  getAMCDataReport(req: any): Observable<any> {
    let requestURl = this.uri + 'reports/getAMCDataReport';
    const request = {
      "fromDate": req.fromDate,
      "toDate": req.toDate,
      "userId": req.userId,
      "userRoleId": req.userRoleId
    };
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.post(requestURl, request, { headers, responseType: 'blob' as 'blob' });
  }

  /**
  * Name: getAMCLeadLevelReport
  * purpose: To export report as excel
  * @param {string} from - start date
  * @param {string} to - end date
  * @param {string} userId creid
  * @param {string} roleId - cre roleId
  * @param {string} workshopCode - WorkshopCode
  * @return {Observable} response binary data object.
  */
  getAMCLeadLevelReport(from: string, to: string, selectedProductType: string, userId: string, userRolesId: string): Observable<any> {
    let request = this.uri + 'reports/getAMCLeadLevelReport';
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      fromDate: from,
      toDate: to,
      reportType: selectedProductType,
      userId: userId,
      userRoleId: userRolesId
    });
    return this.http.get(request, { headers, responseType: 'blob' as 'blob' });
  }

  /**
  * Name: callDetails
  * purpose: To get call list
  * @param {string} custCode - custCode
  * @param {string} vin - vin
  * @return {Observable} response status.
  */
  fetchCustCallSeq(custCode: string, vin: string, userRoleId: string, userId: string): Observable<object> {
    const request = this.uri + 'customer360/amc-fetch-cust-call-seq';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        custCode: custCode,
        vin: vin,
        userRole: userRoleId,
        userId: userId
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: amcSaveData
  *
  * purpose: To save customer details and response
  * @param {object} custData - customer details
  * @return {Observable} response flag and status.
  */
  amcSaveData(req: any): Observable<object> {
    const requestUrl = this.uri + 'customer360/amc-savedata';
    const request = {
      "custCde": req.customerId,
      "vin": req.vin,
      "callTypeSaq": req.callTypeSeq,
      "callStartTime": req.callStartTime,
      "callEndTime": req.callEndTime,
      "custCntctInd": req.customerContactInd,
      "responseForNo": req.responseForNo,
      "workShop": req.workShop,
      "levelData": req.levelData,
      "remarks": req.remark,
      "userId": req.userId,
      "amcNewOffering": req.amcNewOffering,
      "amcRenewal": req.amcRenewal,
      "insuranceRenewal": req.insuranceRenewal,
      "extendedWarranty": req.extendedWarranty,
      "customerType": req.customerType,
      "phoneNo": req.phoneNo,
      "customerName": req.customerName,
      "role": req.role,
      "userRoleId": req.userRoleId
    };
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    return this.http.post(requestUrl, request, httpOptions);
  }

  /**
  * Name: getAmcFetchQuestions
  * purpose: To get Amc Questions
  * @param {string} userId - userId
  * @param {string} category - questions category
  * @param {string} roleId - roleId
  * @return {Observable} response customer details.
  */
  getAmcFetchQuestions(userId: string, category: string, roleId: string): Observable<object> {
    const request = this.uri + 'customer360/amc-fetch-questions';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        userId: userId,
        category: category,
        roleId: roleId
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: amcSaveVinFeedback
  * purpose: To save amcSaveVinFeedback
  * @param {any} req - req details to be get
  * @return {Observable} response customer remark flag.
  */
  amcSaveVinFeedback(req: any): Observable<object> {
    const requestUrl = this.uri + 'customer360/amc-save-vin-feedback';
    const request = {
      "userId": req.userId,
      "custCode": req.customerId,
      "vin": req.vin,
      "workshopCode": req.workshopCode,
      "amcFeedback": req.amcFeedback,
      "amcReFeedback": req.amcReFeedback,
      "ewFeedback": req.ewFeedback,
      "irFeedback": req.irFeedback,
      "amcNewOffering": req.amcNewOffering,
      "amcRenewal": req.amcRenewal,
      "insuranceRenewal": req.insuranceRenewal,
      "extendedWarranty": req.extendedWarranty,
      "customerType": req.customerType,
      "phoneNo": req.phoneNo,
      "customerName": req.customerName,
    };

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    return this.http.post(requestUrl, request, httpOptions);
  }

  /**
  * Name: getAutoFilledQuestions
  * purpose: To get Auto filled Questions
  * @param {string} userId - userId
  * @param {string} category - questions category
  * @param {string} customerId - customerId
  * @return {Observable} response customer details.
  */
  getAutoFilledQuestions(customerId: string, category: string, userId: string, vin: string): Observable<object> {
    const request = this.uri + 'customer360/amc-fetch-autofill-question';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        custCode: customerId,
        category: category,
        userId: userId,
        vin: vin,
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: getWorkshopAppointmentFlag
  * purpose: To get Workshop Appointment Falg
  * @param {string} workshopCode - workshopCode
  * @param {string} countryCode - countryCode
  * @return {Observable} response Workshop Appointment Falg details.
  */
  getWorkshopAppointmentFlag(workshopCode: string): Observable<object> {
    const request = this.uri + 'customer360/getWorkshopAppointmentFlag';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        workshopCode: workshopCode,
        countryCode: this.countryCode
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: getcustCallList
  * purpose: To get call list based on customerId
  * @return {Observable} response call list
  */
  getCustCallList(creId: string, callDoneInd: string, custCode: string): Observable<object> {
    const requestUrl = this.uri + 'callList/custCallList';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        creId: creId,
        callDoneInd: callDoneInd,
        custCode: custCode,
        countryCode: this.countryCode
      })
    };
    return this.http.get(requestUrl, httpOptions);
  }

  /**
  * Name: getFollowUpCallList
  * purpose: To get follow up call list based on creId
  * @return {Observable} response follow up call list
  */
  getFollowUpCallList(creId: string, callDoneInd: string): Observable<object> {
    const requestUrl = this.uri + 'callList/followupcallList';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        creId: creId,
        callDoneInd: callDoneInd,
        countryCode: this.countryCode
      })
    };
    return this.http.get(requestUrl, httpOptions);
  }

  /**
  * Name: getcustCallList
  * purpose: To get call list based on customerId
  * @return {Observable} response call list
  */
  getPRSCustCallList(callDoneInd: string, callType: string, custCode: string, roleId: string, userId: string): Observable<object> {
    const requestUrl = this.uri + 'callList/prsCustCallList';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        callDoneInd: callDoneInd,
        callType: callType,
        custCode: custCode,
        countryCode: this.countryCode,
        roleId: roleId,
        userId: userId
      })
    };
    return this.http.get(requestUrl, httpOptions);
  }

  /**
  * Name: getFollowUpCallList
  * purpose: To get follow up call list based on creId
  * @return {Observable} response follow up call list
  */
  getPRSFollowUpCallList(callType: string, roleId: string, userId: string): Observable<object> {
    const requestUrl = this.uri + 'callList/prsFollowupcallList';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        callType: callType,
        countryCode: this.countryCode,
        roleId: roleId,
        userId: userId
      })
    };
    return this.http.get(requestUrl, httpOptions);
  }

  /**
  * Name: getUserDetails
  * purpose: To get sign in user data
  * @param {string} userId - The userId who is signing in
  * @return {Observable} response user info
  */
  getSigninCheck(userId: string): Observable<object> {
    const requestUrl = this.uri + 'auth/getSigninCheck';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        userId: userId
      })
    };
    return this.http.get(requestUrl, httpOptions);
  }

  /**
  * Name: getSigninUpdate
  * purpose: To save uam customer details and response
  * @param {object} userData - uam customer details
  * @return {Observable} response flag and status.
  */
  getSigninUpdate(userId: string, flag: string, count: string): Observable<object> {
    const request = this.uri + 'auth/getSigninUpdate';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        userId: userId,
        flag: flag,
        count: count
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: getCDMStats
  * purpose: To get states value
  * @param {string} creID - customer id whom details to be get
  * @return {Observable} response customer details.
  */
  getCDMStats(creID: string, role: string): Observable<object> {
    const request = this.uri + 'customer360/fetchStatusCount';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        userId: creID,
        role: role
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: cdmCallList
  * purpose: To get customer list
  * @param {string} dealerCode - dealer code
  * @param {string} flag - type of call status to fatch customer list
  * @return {Observable} response customer list.
  */
  cdmCallList(userId: string, role: string, req: any): Observable<object> {
    const requestUrl = this.uri + 'customer360/fetchCdmData';
    const request = {
      "invalidType" : req.invalidType,
      "status" : req.status,
      "startDate" : req.startDate,
      "endDate" : req.endDate,
      "sourceId" : req.sourceId,
      "type" : req.type
    };
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        userId : userId,
        role : role
      })
    };
    return this.http.post(requestUrl, request, httpOptions);
  }

  /**
  * Name: getCustomerDetail
  * purpose: To get Customer Detail
  * @param {string} custId - customer id whom details to be get
  * @return {Observable} response customer details.
  */
  getCustomerDetail(custId: string, ticketId: string, userId: string, role: string): Observable<object> {
    const request = this.uri + 'customer360/fetchCDMCustomerData';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        userId: userId,
        role: role,
        custId: custId,
        ticketId: ticketId,
        countryCode: this.countryCode
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: cdmCallList
  * purpose: To get customer list
  * @param {string} dealerCode - dealer code
  * @param {string} flag - type of call status to fatch customer list
  * @return {Observable} response customer list.
  */
  saveCdmActualData(userId: string, role: string, req: any): Observable<object> {
    const requestUrl = this.uri + 'customer360/saveCdmActualData';
    const httpOptions = {
      headers: new HttpHeaders({
        userId: userId,
        role: role,
        model: req.model
      })
    };
    return this.http.post(requestUrl, req.file, httpOptions);
  }

  /**
  * Name: updateCdmStatus
  * purpose: To get customer list
  * @param {string} dealerCode - dealer code
  * @param {string} flag - type of call status to fatch customer list
  * @return {Observable} response customer list.
  */
  updateCdmStatus(userId: string, role: string, req: any): Observable<object> {
    const requestUrl = this.uri + 'customer360/updateCdmStatus';
    const httpOptions = {
      headers: new HttpHeaders({
        userId: userId,
        role: role,
        model: req.model
      })
    };
    return this.http.post(requestUrl, req.file, httpOptions);
  }

  /**
  * Name: getCustomerDetail
  * purpose: To get Customer Detail
  * @param {string} custId - customer id whom details to be get
  * @return {Observable} response customer details.
  */
  fetchCdmDBData(custId: string, ticketId: string, userId: string, role: string): Observable<object> {
    const request = this.uri + 'customer360/fetchCdmDBData';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        userId: userId,
        role: role,
        custId: custId,
        ticketId: ticketId
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: getCustomerDetail
  * purpose: To get Customer Detail
  * @param {string} file - customer id whom details to be get
  * @return {Observable} response customer details.
  */
  downloadFile(file: string): Observable<any> {
    let request = this.uri + 'customer360/download-file';
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      file: file
    });
    return this.http.get(request, { headers, responseType: 'blob' as 'blob' });
  }

  /**
  * Name: updateCdmStatus
  * purpose: To get customer list
  * @param {string} dealerCode - dealer code
  * @param {string} flag - type of call status to fatch customer list
  * @return {Observable} response customer list.
  */
  createNewTicket(userId: string, role: string, req: any): Observable<object> {
    const requestUrl = this.uri + 'customer360/saveCdmData';
    const httpOptions = {
      headers: new HttpHeaders({
        userId: userId,
        role: role,
        model:req.model
      })
    };
    return this.http.post(requestUrl, req.file, httpOptions);
  }

  /**
  * Name: getCustomerDetail
  * purpose: To get Customer Detail
  * @param {string} custId - customer id whom details to be get
  * @return {Observable} response customer details.
  */
  fetchLogs(custId: string, ticketId: string, userId: string, role: string): Observable<object> {
    const request = this.uri + 'customer360/fetchLogs';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        userId: userId,
        role: role,
        custId: custId,
        ticketId: ticketId
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
   * Name: callAPI
   * purpose: To call customer
   * @param {string} userId - userId
   * @param {string} userContactNo - userContactNo
   * @return {Observable} response blob file.
   */
  callAPI(userId: string, userContactNo: string, customerContactNo: string): Observable<object> {
    const request = this.uri + 'callManagement/callRecordURL';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        creId: userId,
        creContactNo: userContactNo,
        customerContactNo: customerContactNo
      })
    };
    return this.http.get(request, httpOptions);
  }

  saveCustomerDetails(moduleName: string, transId: any, customerID: string, callNumber: any, userContactNo: string, creId: string) {
    const request = this.uri + 'callManagement/saveCustDetail';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        module: moduleName,
        callId: transId,
        customerId: customerID,
        customerNo: callNumber,
        creNo: userContactNo,
        creId: creId
      }).set('Cache-Control', 'no-cache')
        .set('Pragma', 'no-cache'),
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: getNewRowDataExcelReport
  * purpose: To get data grid details after 31st dec 2022
  * @param {string} region - region
  * @param {string} verticle - verticle
  * @param {string} dealerCode - dealerCode
  * @param {string} from - start date
  * @param {string} to - end date
  * @param {string} reportType - reportType
  * @return {Observable} response binary data object.
  */
  getNewPRSRowDataExcelReport(region: string, verticle: string, dealerCode: string, from: string, to: string, reportType: string, userId: string, roleId: string): Observable<any> {
    let request = this.uri + 'reports/newRawDataReportDealerPRS';
    const headers = new HttpHeaders({
    'Content-Type': 'application/json',
    region: region,
    vertical: verticle,
    dealerCode: dealerCode,
    dateFrom: from,
    dateTo: to,
    reportType: reportType,
    creId: userId,
    roleId: roleId,
    countryCode: this.countryCode
    });
    return this.http.get(request, { headers, responseType: 'blob' as 'blob' });
  }

  /**
  * Name: getNewPRSExportExcelReport
  * purpose: To get prs export excel afte 31st dec 2022
  * @param region
  * @param vertical
  * @param workshop
  * @param startDate
  * @param endDate
  * @param userId
  * @param roleId
  */
  getNewPRSExportExcelReport(region: string, vertical: string, workshop: string, startDate: string, endDate: string, userId: string, roleId: string): Observable<any> {
    let request = this.uri + 'reports/newDetailedDataReportDealerPRS';
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      regionFilter: region,
      verticalFilter: vertical,
      workshopFilter: workshop,
      startDate: startDate,
      endDate: endDate,
      userId: userId,
      roleId: roleId,
      countryCode: this.countryCode
    }).set('Cache-Control', 'no-cache')
      .set('Pragma', 'no-cache');
    return this.http.get(request, { headers, responseType: 'blob' as 'blob' });
  }

  fetchCdmData(Data) {
    // const request = 'http://169.38.80.10:30066/cdm/fetchData';
    const request = this.uri + 'customer360/fetchData';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'clientId': 'Service App',
        'clientSecret': 'CDMClientKey'
      })
    };
    return this.http.post(request, Data, httpOptions);
  }

  /**
    * Name: getOperationalDashboardReport
    * purpose: To export Operational Dashboard Report as excel
    * @param {string} userId creid
    * @return {Observable} response binary data object.
    */
   getOperationalDashboardReport(userId: string): Observable<any> {
    let request = this.uri + 'reports/operationalDashboardReport';
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      userId: userId
    });
    return this.http.get(request, { headers, responseType: 'blob' as 'blob' });
  }

  /**
  * Name: getNewPRSRowLeadDataExcelReport
  * purpose: To get prs lead raw data Report after 31 dec 2022
  * @param region
  * @param vertical
  * @param dealerCode
  * @param from
  * @param to
  * @param reportType
  * @param userId
  * @param roleId
  */
   getNewPRSRowLeadDataExcelReport(region: string, vertical: string, dealerCode: string, from: string, to: string, reportType: string, userId: string, roleId: string): Observable<any> {
    let request = this.uri + 'reports/newLeadRawReportDealerPRS';
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      region: region,
      vertical: vertical,
      dealerCode: dealerCode,
      dateFrom: from,
      dateTo: to,
      reportType: reportType,
      creId: userId,
      roleId: roleId,
      countryCode: this.countryCode
    })
    return this.http.get(request, { headers, responseType: 'blob' as 'blob' });
  }

  /**
    * Name: getLostCustomerProcessReport()
    * purpose: To export report as excel
    * @param {string} from - start date
    * @param {string} to - end date
    * @param {string} userId creid
    * @param {string} roleId - cre roleId
    * @param {string} workshopCode - WorkshopCode
    * @return {Observable} response binary data object.
    */
  getLostCustomerProcessReport(from: string, to: string, userId: string, roleId: string, workshopCode: string): Observable<any> {
    let request = this.uri + 'reports/getLostCustomerProcessReport';
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      userId: userId,
      roleId: roleId,
      fromDate: from,
      toDate: to,
      workshopFilter: workshopCode,
      countryCode: this.countryCode
    }).set('Cache-Control', 'no-cache')
      .set('Pragma', 'no-cache');
    return this.http.get(request, { headers, responseType: 'blob' as 'blob' });
  }

  /**
  * Name: LostCustomerList
  * purpose: To get customer contact detail
  * @param {string} creID - customer id whom details to be get
  * @return {Observable} response customer details.
  */
   getLostCreCallStats(smeId: string): Observable<object> {
    const request = this.uri + 'callList/lostcustCallStats';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        creId: smeId,
        countryCode: this.countryCode
      }).set('Cache-Control', 'no-cache')
        .set('Pragma', 'no-cache'),
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: lostCallListinfo
  * purpose: To get call list counts
  * @param {string} dealerCode - dealer code
  * @return {Observable} response call count and list info.
  */
   lostCallListinfo(smeId: string): Observable<object> {
    const request = this.uri + 'callList/lostCustCallsCount';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        creId: smeId,
        countryCode: this.countryCode
      }).set('Cache-Control', 'no-cache')
        .set('Pragma', 'no-cache'),
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: LostcustomercallList
  * purpose: To get customer list
  * @param {string} dealerCode - dealer code
  * @param {string} flag - type of call status to fatch customer list
  * @return {Observable} response customer list.
  */
  lostCustomerCallList(smeId: string, flag: string): Observable<object> {
    const request = this.uri + 'callList/lostcustProposalCallList';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        creId: smeId,
        callDoneInd: flag,
        countryCode: this.countryCode
      }).set('Cache-Control', 'no-cache')
        .set('Pragma', 'no-cache'),
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: LostcustomercallList
  * purpose: To get customer list
  * @param {string} dealerCode - dealer code
  * @param {string} flag - type of call status to fatch customer list
  * @return {Observable} response customer list.
  */
   lostCustomerVisitCallList(smeId: string, flag: string): Observable<object> {
    const request = this.uri + 'callList/lostcustVisitingCallList';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        creId: smeId,
        callDoneInd: flag,
        countryCode: this.countryCode
      }).set('Cache-Control', 'no-cache')
        .set('Pragma', 'no-cache'),
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: visitCallListinfo
  * purpose: To get call list counts
  * @param {string} dealerCode - dealer code
  * @return {Observable} response call count and list info.
  */
   visitCallListinfo(smeId: string): Observable<object> {
    const request = this.uri + 'callList/visitCustCallCount';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        creId: smeId,
        countryCode: this.countryCode
      }).set('Cache-Control', 'no-cache')
        .set('Pragma', 'no-cache'),
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: getcustomerdata
  * purpose: To get customer details
  * @param {string} customerID - customer id whom details to be get
  * @param {string} dealerCode - login dealer's codeF
  * @return {Observable} response customer details.
  */
   getLostcustomerdata(customerID: string, dealerCode: string, vin: string): Observable<object> {
    const request = this.uri + 'customer360/getlostcustomerdata';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        customerID: customerID,
        dealerCode: dealerCode,
        vin: vin,
        countryCode:this.countryCode
      })
    };
    return this.http.get(request, httpOptions);
  }

  getLostDropdownData(callType: number): Observable<object> {
    const request = this.uri + 'customer360/lostcustomeresponse';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        callType: callType && callType.toString(),
        countryCode:this.countryCode
      }).set('Cache-Control', 'no-cache')
        .set('Pragma', 'no-cache'),
    };
    return this.http.get(request, httpOptions);
  }

  getLostBookingFollowupCount(customerID: string, vin: string, module: string): Observable<object> {
    const request = this.uri + 'customer360/getlostcustomerBookingFollowupCount';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        custCode: customerID,
        vin: vin,
        module: module
      }).set('Cache-Control', 'no-cache')
        .set('Pragma', 'no-cache'),
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name:  getAutoFillVisitReport
  * purpose: To auto fill visit report in lost customer module
  */
  getAutoFillVisitReport():Observable<object> {
    const request = this.uri + 'customer360/getAutofillVisitReport';
    const httpOptions={
      headers:new HttpHeaders({
        vin: localStorage.getItem('chassisNo'),
        custcode:localStorage.getItem('customerId'),
        countryCode:this.countryCode
      }).set('Cache-Control','no-cache')
      .set('Pragma','no-cache'),
    };
    return this.http.get(request,httpOptions);
  }

  /**
  * Name:  saveVisitReportForm
  * purpose: To save visit report in lost customer module
  */
  saveVisitReportForm(totalFleetCount:string, newProposal:string, newVehicle:string, softOff:string, remark:string, workshopVisit:string, attachmentName:string, file:any){
    const request = this.uri + 'customer360/saveAutofillVisitReport';
    const httpOptions = {
      headers: new HttpHeaders({
        vin:localStorage.getItem('chassisNo'),
        customerId:localStorage.getItem('customerId'),
        countryCode:this.countryCode,
        totalFleetCount:totalFleetCount,
        newProposal:newProposal,
        newVehicle:newVehicle,
        softOff:softOff,
        remark:remark,
        workshopVisit:workshopVisit,
        visitPhoto:attachmentName
      }),
    };
    return this.http.post(request, file, httpOptions);
  }

  /**
  * Name: saveLostCustomerData
  * purpose: To save lost customer details and response
  * @param {object} custData - customer details
  * @return {Observable} response flag and status.
  */
  saveLostCustomerData(custData: any): Observable<object> {
    const request = this.uri + 'customer360/savelostcustomerdata';
    const httpOptions = {
      headers: new HttpHeaders({
        countryCode: this.countryCode,
        'Content-Type': 'application/json',
      }).set('Cache-Control', 'no-cache')
        .set('Pragma', 'no-cache'),
    };
    return this.http.post(request, custData, httpOptions);
  }

  getCustomerProfile(customerCode:string){
    const request=this.uri + 'customer360/customerVehicleProfile';
    const httpOptions ={
      headers:new HttpHeaders({
        customerCode:customerCode,
        countryCode:this.countryCode
      }),
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: fetchWmCloseLeads
  * purpose: To fetch WM leads
  * @param {any} req - req details to be get
  * @return {Observable} response customer details.
  */
  fetchWmCloseLeads(userId: string) {
    const request = this.uri + 'customer360/fetchWmCloseLeads';
    const httpOptions ={
      headers: new HttpHeaders({
        userId: userId,
        countryCode:this.countryCode
      }),
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name:    updateLeadStatus
  * purpose: To update lead status WM lead update .
  */
  updateLeadStatus(customerCode: string, vin: string, leadStatus: string, remarks: string, userId: string) {
    const request = this.uri + 'customer360/wmLeadStatusUpdate';
    const httpOptions ={
      headers: new HttpHeaders({
        customerCode: customerCode,
        vin: vin,
        status: leadStatus,
        remarks: remarks,
        userId: userId,
        countryCode: this.countryCode
      }),
    };
    return this.http.get(request, httpOptions);
  }

  saveComplaintDialog(customerId: string, preferredLanguage: string, vehRegNo: string, vehicleType: string, chassisNo: string, dealerCode: string, complaintRemarks: string, category1: string, category2:string, category3: string, source: string, additionalRemarks: string){
    const requestUrl = this.uri + 'customer360/getComplaintId';
    const request = {
      "CustomerId" :customerId,
      "Language" :preferredLanguage,
      "VehicleRegNo" :vehRegNo ,
      "VehicleType" :vehicleType ,
      "VehicleChassisNo" : chassisNo,
      "DealerScode" : dealerCode,
      "ComplaintDescription" :complaintRemarks,
      "Category1" : category1,
      "Category2" : category2,
      "Category3" : category3,
      "Source" :source ,
      "ComplaintRemark" : additionalRemarks ,
      };

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }).set('Cache-Control', 'no-cache')
          .set('Pragma', 'no-cache'),
      };
      return this.http.post(requestUrl,request, httpOptions);
    }

  complaintCheck(JCnumber: string, userRoleId: string, userId:string, callTypeCode: string,customerCode: string, vin: string) {
    const request = this.uri + 'customer360/CustomerComplaintCheck';
    const httpOptions ={
      headers: new HttpHeaders({
        customerCode: customerCode,
        JCnumber:JCnumber,
        vin: vin,
        callTypeCode: callTypeCode,
        userRoleId: userRoleId,
        userId: userId
      }),
    };
    return this.http.get(request, httpOptions);
  }

  saveComplaint( JCnumber: string, userRoleId: string, userId:string, callTypeCode: string, complaintId:string,customerCode: string, vin: string) {
    const request = this.uri + 'customer360/saveComplaint';
    const httpOptions ={
      headers: new HttpHeaders({
        customerCode: customerCode,
        JCnumber: JCnumber,
        vin: vin,
        complaintId: complaintId,
        callTypeCode: callTypeCode,
        userRoleId: userRoleId,
        userId: userId
      }),
    };
    return this.http.get(request, httpOptions);
  }

  complainUpdateCallList(customerId: string, chassisNo: string, JCnumber: string, callTypeCode: string, dealerCode: string, roleId: string){
    const request = this.uri + 'customer360/complainUpdateCallList';
    const httpOptions = {
      headers: new HttpHeaders({
        customerCode: customerId,
        vin: chassisNo,
        JCnumber: JCnumber,
        callTypeCode: callTypeCode,
        userId: dealerCode,
        userRoleId: roleId,
        countryCode: this.countryCode
      }),
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: prsFilterDashboard
  * purpose: To filter dashboard for prs
  */
  prsFilterDashboard(userId: any, roleId:any): Observable<object> {
    const request = this.uri + 'reports/getPrsDashboardFilter';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        userId: userId,
        roleId: roleId,
        countryCode: this.countryCode
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: getprsDashboardResponseKpi
  * purpose: To get getPrsDashboardResponseKpi
  * @param {any} req - req details to be get
  * @return {Observable} response customer details.
  */

  getPrsDashboardResponseKpi(req: any): Observable<object> {
    const requestUrl = this.uri + 'reports/getPrsDashboardResponseKpi';
    const request = {
      "userId": req.userId,
      "roleId": req.roleId,
      "creId": req.creId,
      "workshopCode": req.workshopCode,
      "startDate": req.startDate,
      "endDate": req.endDate,
      "PrsRoleId": req.PrsRoleId,
      "callTypeSeq": "3",
      "countryCode": this.countryCode
    };
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    return this.http.post(requestUrl,request, httpOptions);
  }

  getPrsDashboardComparisonKpi(req: any): Observable<object> {
    const requestUrl = this.uri + 'reports/getPrsDashboardComparisonKpi';
    const request = {
      "userId": req.userId,
      "roleId": req.roleId,
      "creId": req.creId,
      "workshopCode": req.workshopCode,
      "startDate": req.startDate,
      "endDate": req.endDate,
      "PrsRoleId": req.PrsRoleId,
      "callTypeSeq": "3",
      "countryCode": this.countryCode
    };

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }).set('Cache-Control', 'no-cache')
        .set('Pragma', 'no-cache'),
    };
    return this.http.post(requestUrl,request, httpOptions);
  }

  /**
  * Name: getDashboardKpi
  * purpose: To get getDashboardKpi
  * @param {any} req - req details to be get
  * @return {Observable} response customer details.
  */
   getPrsDashboardLeadKpi(req: any): Observable<object> {
    const requestUrl = this.uri + 'reports/getPrsDashboardLeadKpi';
    const request = {
      "userId": req.userId,
      "roleId": req.roleId,
      "creId": req.creId,
      "workshopCode": req.workshopCode,
      "startDate": req.startDate,
      "endDate": req.endDate,
      "PrsRoleId": req.PrsRoleId,
      "callTypeSeq": "3",
      "countryCode": this.countryCode
    };

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }).set('Cache-Control', 'no-cache')
        .set('Pragma', 'no-cache'),
    };
    return this.http.post(requestUrl,request, httpOptions);
  }

  /**
  * Name:  workshopReassignmentList
  * purpose: To show reassignment list to call center agent
  */
  workshopReassignmentList(){
    const requestUrl = this.uri + 'customer360/LostCustWorkshopReassignmentList';
    const httpOptions = {
      headers: new HttpHeaders({
        countryCode: this.countryCode
      }),
    };
    return this.http.get(requestUrl, httpOptions);
  }

  /**
    * Name:   lcWorkshopReassignmentVehicleDetails
    * purpose: To get vehicle details for reassignment to call center agent
    */
    lcWorkshopReassignmentVehicleDetails(customerCode:any){
      const requestUrl = this.uri + 'customer360/LCworkshopReassignmentVehicleDetails';
      const httpOptions = {
        headers: new HttpHeaders({
          countryCode: this.countryCode,
          customerCode:customerCode
        }),
      };
      return this.http.get(requestUrl, httpOptions);
    }

    /**
    * Name:   LostCustWorkshopDetailsFilter
    * purpose: To get workshop details for reassignment to call center agent
    */
    LostCustWorkshopDetailsFilter(){
      const requestUrl = this.uri + 'customer360/LostCustWorkshopDetails';
      const httpOptions = {
        headers: new HttpHeaders({
          countryCode: this.countryCode,
        }),
      };
      return this.http.get(requestUrl, httpOptions);
    }

    /**
    * Name:    saveWorkshopReassignment
    * purpose: To save workshop reassignment .
    */
     saveWorkshopReassignment(custData: any ){
      const requestUrl = this.uri + 'customer360/saveWorkshopReassignment';
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }).set('Cache-Control', 'no-cache')
          .set('Pragma', 'no-cache'),
      };
      return this.http.post(requestUrl,custData, httpOptions);
    }
  /**
  * Name:    LCWorkshopManagerLeadsVehicleDetails
  * purpose: To get vehicle details for WM lead update .
  * @param {string} customerCode - customer code
  * @return {Observable} response object of vehicle details.
  */
  LCWorkshopManagerLeadsVehicleDetails(customerCode : string){
    const request= this.uri + 'customer360/LCWorkshopManagerLeadsVehicleDetails';
    const httpOptions = {
      headers: new HttpHeaders({
      customerCode: customerCode,
      countryCode: this.countryCode,
    }).set('Cache-Control', 'no-cache')
    .set('Pragma', 'no-cache')
    };
    return this.http.get(request,httpOptions);
  }

  /**
  * Name: getLostVisitFormReport
  * purpose: To download report of visit form .
  * @param {string} from - start date
  * @param {string} to - end date
  * @param {string} userId Userid
  * @param {string} roleId - cre roleId
  * @param {string} workshopCode - WorkshopCode
  * @return {Observable} response binary data object.
  */
  getLostVisitFormReport(from : string, to: string, userId: string, roleId: string, workshopCode: string) {
    let request = this.uri + 'reports/getLostSmeVisitReport';
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      userId: userId,
      roleId: roleId,
      fromDate: from,
      toDate: to,
      workshopFilter: workshopCode,
      countryCode: this.countryCode
    }).set('Cache-Control', 'no-cache')
    .set('Pragma', 'no-cache');
    return this.http.get(request, { headers, responseType: 'blob' as 'blob' });
  }

  /**
  * Name: LostCustomerVisitReportCheck
  * purpose: To check report of visit form .
  * @param {string} customerCode - start date
  * @param {string} vin - end date
  * @param {string} userId- userId
  * @return {Observable} response messagge abou visit report status.
  */
  LostCustomerVisitReportCheck(customerCode: string, vin: string, userId: string){
    const request= this.uri + 'reports/LostCustomerVisitReportCheck';
    const httpOptions = {
      headers: new HttpHeaders({
      customerCode: customerCode,
      vin: vin,
      userId: userId
    }).set('Cache-Control', 'no-cache')
    .set('Pragma', 'no-cache')
    };
    return this.http.get(request,httpOptions);
  }

  /**
    * Name: fetchBlockStatus
    * purpose: To get block owner number detail
    * @param {string} custCode - customer Code
    * @param {string} module - module
    * @return {Observable} response status.
    */
    fetchBlockStatus(custCode: string, module: string): Observable<object> {
      const request = this.uri + 'customer360/fetchBlockStatus';
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          custCode: custCode,
          module: module
        }).set('Cache-Control', 'no-cache')
          .set('Pragma', 'no-cache'),
      };
      return this.http.get(request, httpOptions);
    }

  /**
  * Name: prscustomercallListSearch
  * purpose: To get customer list
  * @param {string} flag - type of call status to fatch customer list
  * @return {Observable} response customer list.
  */
  prscustomercallListSearch(flag: string, callType: string, userId: string, roleId: string, vin: string): Observable<object> {
    const request = this.uri + 'callList/prsSearchRecord';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        listType: flag,
        callType: callType,
        userId: userId,
        countryCode: this.countryCode,
        roleId: roleId,
        vin: vin
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: pipelineCustomerCallList
  * purpose: To get customer list
  * @param {string} flag - type of call status to fatch customer list
  * @return {Observable} response customer list.
  */
  pipelineCustomerCallList(creId: string): Observable<object> {
    const request = this.uri + 'callList/pipeline-customerCallList';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        creId: creId,
        countryCode: this.countryCode
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name:    getPipelineDataReport
  * purpose: To download report of pipeline management .
  * @param {string} from - start date
  * @param {string} to - end date
  * @return {Observable} response binary data object.
  */
  getPipelineDataReport(fromDate: string, toDate: string, userId: string) {
    const request = this.uri + 'reports/getPipelineDataReport';
    const headers = new HttpHeaders({
      fromDate: fromDate,
      toDate: toDate,
      userId: userId
    }).set('Cache-Control', 'no-cache')
      .set('Pragma', 'no-cache');
    return this.http.get(request, { headers, responseType: 'blob' as 'blob' });
  }

  /**
  * Name:    customerNameSuggestionFilter
  * purpose: To suggest names for search in pipeline management .
  * @return {Observable} response array data object.
  */
  customerNameSuggestionFilter() {
    const request = this.uri + 'callList/CustomerNameSuggestion';
    const httpOptions = {
      headers: new HttpHeaders({
        countryCode: this.countryCode,
        'Content-Type': 'application/json',
      }).set('Cache-Control', 'no-cache')
        .set('Pragma', 'no-cache'),
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name:    pipelineSearchFilter
  * purpose: To filter data for search in pipeline management .
  * @return {Observable} response array data object.
  */
  pipelineSearchFilter(custCode: string, custMobile: string, regNo: string, custName: string, vin: string, startDate: string, endDate: string, model: string) {
    const request = this.uri + 'callList/getSearchCustomerData';
    const httpOptions = {
      headers: new HttpHeaders({
        custCode: custCode,
        custMobile: custMobile,
        regNo: regNo,
        custName: custName,
        vin: vin,
        startDate: startDate,
        endDate: endDate,
        model: model,
        countryCode: this.countryCode,
        'Content-Type': 'application/json',
      }).set('Cache-Control', 'no-cache')
        .set('Pragma', 'no-cache'),
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name:    enquiryDialogFilter
  * purpose: To filter data for enquiry in pipeline management .
  * @return {Observable} response array data object.
  */
  enquiryDialogFilter() {
    const request = this.uri + 'callList/enquiryDropdowns';
    return this.http.get(request);
  }

  /**
  * Name: updatePipelineLeadStatus
  * purpose: To update lead status
  * @param {string} custData - customer data
  * @return {Observable} response message
  */
  updatePipelineLeadStatus(custData: any): Observable<object> {
    const request = this.uri + 'callList/pipelineUpdateEnquiry';
    const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }).set('Cache-Control', 'no-cache')
      .set('Pragma', 'no-cache'),
    };
   return this.http.post(request, custData, httpOptions);
  }

  /**
  * Name: createPipelineEnquiry
  * purpose: To create pipeline enquiry
  * @param {string} custData - customer data
  * @return {Observable} response message
  */
  createPipelineEnquiry(custData: any): Observable<object> {
    const request = this.uri + 'callList/pipelineCreateEnquiry';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }).set('Cache-Control', 'no-cache')
        .set('Pragma', 'no-cache'),
    };
    return this.http.post(request, custData, httpOptions);
  }

  /**
  * Name: getModelSuggestionFilter()
  * purpose: To show suggestion for model to user .
  * @return {Observable} Array of vehicle models.
  */
  getModelSuggestionFilter() {
    const request = this.uri + 'callList/getVehicleModelSuggestion';
    const httpOptions = {
      headers: new HttpHeaders({
        countryCode: this.countryCode,
        'Content-Type': 'application/json',
      })
    };
    return this.http.get(request, httpOptions);
  }

  getSrmUpcomingServiceReport(from: string, to: string): Observable<any> {
        let request = this.uri + 'reports/getSrmUpcomingServiceReport';
        const headers = new HttpHeaders({
          'Content-Type': 'application/json',
          startDate: from,
          endDate: to,
        }).set('Cache-Control', 'no-cache')
          .set('Pragma', 'no-cache');
        return this.http.get(request, { headers, responseType: 'blob' as 'blob' });
  }

  /**
   * Name:getPipelineRegionWiseDataReport()
   * purpose: To export report as excel
   * @param {string} from - start date
   * @param {string} to - end date
   * @param {string} userId creid
   * @param {string} userRoleId - cre roleId
   * @return {Observable} response binary data object.
  */
  getPipelineRegionWiseDataReport(from: string, to: string, userId: string, userRoleId: string): Observable<any>{
    let request = this.uri + 'reports/getPipelineRegionWiseDataReport';
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      userId: userId,
      userRoleId: userRoleId,
      fromDate: from,
      toDate: to,
    }).set('Cache-Control', 'no-cache')
      .set('Pragma', 'no-cache');
    return this.http.get(request, { headers, responseType: 'blob' as 'blob' });
  }

  /**
 * Name: getDoorstepCustomerVinDetails
 * purpose: To get vin data for Doorstep customer
 * @param {string} customerCode - customer code
 * @param {string} creId - creId
 * @param {string} vin - vin
 * @return {Observable} response data object for response auto dropdown.
 */
   getDoorstepCustomerVinDetails(customerCode: string, creId: string, vin: string): Observable<object> {
    const request = this.uri + 'customer360/getDoorStepCustomerVinDetails-inbound';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        creId: creId,
        customerCode: customerCode,
        vin: vin
      }).set('Cache-Control', 'no-cache')
        .set('Pragma', 'no-cache'),
    };
    return this.http.get(request, httpOptions);
  }

  /**
   * Name: saveDoorstepServiceData
   * purpose: To save vehicle service details and response for doorstep
   * @param {object} serviceData - customer details
   * @return {Observable} response flag and status.
   */
  saveDoorstepServiceData(serviceData: any): Observable<object> {
    const request = this.uri + 'inboundCall/saveDoorstepServiceData';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        countryCode: this.countryCode
      }).set('Cache-Control', 'no-cache')
        .set('Pragma', 'no-cache'),
    };
    return this.http.post(request, serviceData, httpOptions);
  }


  doorStepCustomerCallList(dealerCode: string, flag: string): Observable<object> {
    const request = this.uri + 'callList/doorStepCustomerCallList';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        smeId: dealerCode,
        callDoneInd: flag,
        countryCode: this.countryCode
      }).set('Cache-Control', 'no-cache')
        .set('Pragma', 'no-cache'),
    };
    return this.http.get(request, httpOptions);
  }

  doorStepCallsCount(dealerCode: string): Observable<object> {
    const request = this.uri + 'callList/doorStepCallsCount';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        smeId: dealerCode,
        countryCode: this.countryCode
      }).set('Cache-Control', 'no-cache')
        .set('Pragma', 'no-cache'),
    };
    return this.http.get(request, httpOptions);
  }


  doorStepCustomerDetails(customerID: string, dealerCode: string, vin: string): Observable<object> {
    const request = this.uri + 'customer360/getDoorStepCustomerData';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        customerCode: customerID,
        smeId: dealerCode,
        vin: vin,
        countryCode: this.countryCode
      }).set('Cache-Control', 'no-cache')
        .set('Pragma', 'no-cache'),
    };
    return this.http.get(request, httpOptions);
  }

  doorStepUpdateContact(number: string, contactNoOld: string, type: string, custId: string, userId: string, oldName: string, newName: string): Observable<object> {
    const request = this.uri + 'customer360/doorStepUpdateContact';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        contactNoNew: number,
        contactNoOld: contactNoOld,
        custId: custId,
        userId: userId,
        type: type,
        oldDriverName: oldName,
        newDriverName: newName
      }).set('Cache-Control', 'no-cache')
        .set('Pragma', 'no-cache'),
    };
    return this.http.get(request, httpOptions);
  }

  doorStepContactDetails(customerID: string): Observable<object> {
    const request = this.uri + 'customer360/doorStepContactDetails';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        customerCode: customerID
      }).set('Cache-Control', 'no-cache')
        .set('Pragma', 'no-cache'),
    };
    return this.http.get(request, httpOptions);
  }

  doorStepCallStats(smeID: string): Observable<object> {
    const request = this.uri + 'callList/doorStepCallStats';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        smeId: smeID,
        countryCode: this.countryCode
      }).set('Cache-Control', 'no-cache')
        .set('Pragma', 'no-cache'),
    };
    return this.http.get(request, httpOptions);
  }

  getDoorStepCustomerResponse(callType: number): Observable<object> {
    const request = this.uri + 'customer360/getDoorStepCustomerResponse';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        countryCode: this.countryCode,
        callType: callType && callType.toString(),
      }).set('Cache-Control', 'no-cache')
        .set('Pragma', 'no-cache'),
    };
    return this.http.get(request, httpOptions);
  }

  saveDoorStepData(custData: any): Observable<object> {
    const request = this.uri + 'customer360/saveDoorStepData';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        countryCode: this.countryCode,
      }).set('Cache-Control', 'no-cache')
        .set('Pragma', 'no-cache'),
    };
    return this.http.post(request, custData, httpOptions);
  }

  /**
  * Name: periodFilter
  * purpose: To get periodFilter Dashboard
  * @param {any} userInfo - userInfo whom details to be get
  * @return {Observable} response filter details.
  */
  doorStepPeriodFilter(userInfo: any): Observable<object> {
    const request = this.uri + 'reports/doorStepPeriodFilter';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        userId: userInfo.userId,
        roleId: userInfo.roleId,
        countryCode: this.countryCode
      }).set('Cache-Control', 'no-cache')
        .set('Pragma', 'no-cache'),
    };
    return this.http.get(request, httpOptions);
  }

  doorstepFilterDashboard(userInfo: any): Observable<object> {
    const request = this.uri + 'reports/doorStepFilterDashboard';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        userId: userInfo.userId,
        roleId: userInfo.roleId,
        countryCode: this.countryCode
      }).set('Cache-Control', 'no-cache')
        .set('Pragma', 'no-cache'),
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: getDashboardKpi
  * purpose: To get getDashboardKpi
  * @param {any} req - req details to be get
  * @return {Observable} response customer details.
  */
  getDoorStepDashboardKpi(req: any): Observable<object> {
    const requestUrl = this.uri + 'reports/getDoorStepDashboardKpi';
    const request = {
      "userId": req.userId,
      "roleId": req.roleId,
      "smeId": req.creId,
      "workshopCode": req.workshopCode,
      "service": req.service,
      "startDate": req.startDate,
      "endDate": req.endDate
    };

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        countryCode: this.countryCode
      }).set('Cache-Control', 'no-cache')
        .set('Pragma', 'no-cache'),
    };
    return this.http.post(requestUrl, request, httpOptions);
  }

  /**
  * Name: getDashboardKpiCard
  * purpose: To get DashboardKpiCard
  * @param {any} req - req details to be get
  * @return {Observable} response customer details.
  */
  getDoorStepDashboardKpiCard(req: any): Observable<object> {
    const requestUrl = this.uri + 'reports/getDoorStepDashboardKpiCard';
    const request = {
      "userId": req.userId,
      "roleId": req.roleId,
      "smeId": req.creId,
      "workshopCode": req.workshopCode,
      "service": req.service,
      "month": req.month,
      "year": req.year
    };

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        countryCode: this.countryCode
      }).set('Cache-Control', 'no-cache')
        .set('Pragma', 'no-cache'),
    };
    return this.http.post(requestUrl, request, httpOptions);
  }

  /**
  * Name: getDoorStepDashboardResponseKpi
  * purpose: To get getDoorStepDashboardResponseKpi
  * @param {any} req - req details to be get
  * @return {Observable} response customer details.
  */
  getDoorStepDashboardResponseKpi(req: any): Observable<object> {
    const requestUrl = this.uri + 'reports/getDoorStepDashboardResponseKpi';
    const request = {
      "userId": req.userId,
      "roleId": req.roleId,
      "smeId": req.creId,
      "workshopCode": req.workshopCode,
      "service": req.service,
      "startDate": req.startDate,
      "endDate": req.endDate
    };

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
         countryCode: this.countryCode
      }).set('Cache-Control', 'no-cache')
        .set('Pragma', 'no-cache'),
    };
    return this.http.post(requestUrl, request, httpOptions);
  }

  /**
  * Name: getDoorStepDashboardServiceKpi 
  * purpose: To get getDoorStepDashboardServiceKpi 
  * @param {any} req - req details to be get
  * @return {Observable} response customer details.
  */
  getDoorStepDashboardServiceKpi(req: any): Observable<object> {
    const requestUrl = this.uri + 'reports/getDoorStepDashboardServiceKpi';
    const request = {
      "userId": req.userId,
      "roleId": req.roleId,
      "smeId": req.creId,
      "workshopCode": req.workshopCode,
      //"service": req.service,
      "startDate": req.startDate,
      "endDate": req.endDate
    };

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        countryCode: this.countryCode
      }).set('Cache-Control', 'no-cache')
        .set('Pragma', 'no-cache'),
    };
    return this.http.post(requestUrl, request, httpOptions);
  }

  /**
  * Name: getDoorstepDashboardReport
  * purpose: To export report as excel
  * @param {string} startDate - start date
  * @param {string} endDate - end date
  * @param {string} userId userId
  * @param {string} roleId - cre roleId
  * @param {string} creid creid
  * @param {string} serviceType serviceType
  * @param {string} workshopFilter - WorkshopCode
  * @return {Observable} response binary data object.
  */
  getDoorstepDashboardReport(userId: string, roleId: string, smeId: string, startDate: string, endDate: string, serviceType: string, workshopFilter: string): Observable<any> {
    let request = this.uri + 'reports/getDoorStepDashboardReport';
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      countryCode: this.countryCode,
      userId: userId,
      roleId: roleId,
      smeId: smeId,
      workshopCode: workshopFilter,
      startDate: startDate,
      endDate: endDate,
      serviceType: serviceType,
    }).set('Cache-Control', 'no-cache')
      .set('Pragma', 'no-cache');
    return this.http.get(request, { headers, responseType: 'blob' as 'blob' });
  }



  /**
    * Name: getDoorstepProcessReport()
    * purpose: To export report as excel
    * @param {string} from - start date
    * @param {string} to - end date
    * @param {string} userId creid
    * @param {string} roleId - cre roleId
    * @param {string} workshopCode - WorkshopCode
    * @return {Observable} response binary data object.
    */
  getDoorstepProcessReport(from: string, to: string, userId: string, roleId: string, workshopCode: string): Observable<any> {
    let request = this.uri + 'reports/getDoorStepDetailedProcessReport';
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      userId: userId,
      roleId: roleId,
      fromDate: from,
      toDate: to,
      workshopFilter: workshopCode,
      countryCode: this.countryCode
    }).set('Cache-Control', 'no-cache')
      .set('Pragma', 'no-cache');
    return this.http.get(request, { headers, responseType: 'blob' as 'blob' });
  }

  /**
   * Name: callRecordURL
   * purpose: To call customer
   * @param {string} androidId - androidId
   * @param {string} contactNo - contactNo
   * @return {Observable} response blob file.
   */
  callRecordURL(contactNo: string, androidId: string): Observable<object> {
    const request = this.uri + 'customer360/callRecordURL';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        contactNo: contactNo,
        androidId: androidId
      })
    };
    return this.http.get(request, httpOptions);
  }

  /**
  * Name: postPBBCall()
  * purpose: To create new post body building
  * @param {any} data - req details to be get
  * @return {Observable} response binary data object.
  */
createMaster(data): Observable<any> {
  return this.http.post<any>(this.uri + 'callList/pbbcallconfig', data);
}

/**
* Name: Get master by Fert Code
* purpose: To get a master using the fert code.
* @param {string} fertCode - FertCode required
* @return {Observable} response binary data object.
*/
getMasterByFertCode(fertCode: string): Observable<any> {
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'fertCode': fertCode, 
    })
  };
  return this.http.get<any>(this.uri + 'callList/pbbcallconfig', httpOptions);
}

/**
* Name: Get master by id
* purpose: To find data for search in Post Body Building .
* @return {Observable} response array data object.
*/
getMasterById(id: number): Observable<any> {
  return this.http.get<any>(`${this.uri}callList/pbbcallconfig/${id}`);
}

/**
* Name: Update master by id
* purpose: To get FertCode master for PBBI
* @param {string} fertCode - Get FertCode
* @return {Observable} response.
*/
updateMaster(data, id: number): Observable<any> {
  return this.http.put<any>(this.uri + `callList/pbbcallconfig/${id}`, data);
}

/**
* Name: Find masters based on different properties
* purpose: To Find masters based on different properties
* @param {number} id - Get FertCode
* @return {Observable} response.
*/
findMasters(params, page: number, pageSize: number, search: any): Observable<any> {
  return this.http.get<any>(this.uri + `callList/pbbcallconfig/find?page=${page}&pageSize=${pageSize}&search=${search}`, {params});
}

/**
* Name: Download masters
* purpose: To put ID from Master for PBBI
* @param {number} id - Get FertCode
* @return {Observable} response.
*/
downloadMasters(): Observable<any> {
  return this.http.get<any>(this.uri + 'callList/pbbcallconfig/download', { responseType: 'blob' as 'json' });
}

/**
* Name: Create master by CSV
* purpose: To put ID from Master for PBBI
* @param {number} id - Get FertCode
* @return {Observable} response.
*/
createMasterByCsv(file: File): Observable<any>  {
  let formData: FormData = new FormData();
  formData.append('file', file, file.name);
  return this.http.post<any>(this.uri + 'callList/pbbcallconfig/csv', formData);
}

private generateQueryString(params: any): string {
  let queryString = '?';
  for (const key in params) {
    if (params.hasOwnProperty(key) && params[key] !== undefined && params[key] !== null) {
      queryString += `${key}=${params[key]}&`;
    }
  }
  return queryString.slice(0, -1); 
}


createCallConnection_API(params:CallParams){
  return this.http.post<any>(`${this.uri}callManagement/exotel/call${this.generateQueryString(params)}`,'');
}
saveCallRecording_API(params:SaveCallRecordingParams){
  return this.http.post<any>(`${this.uri}callManagement/exotel/save-call-record${this.generateQueryString(params)}`,'');
}

  /**
  * Name: getTitanDealerDashboardData
  * purpose: To get getTitanDealerDashboardData
  * @param {any} req - req details to be get
  * @return {Observable} response titan dealer details.
  */
  getTitanDealerDashboardData(req: any): Observable<object> {
    const requestUrl = this.uri + 'customer360/getTitanSlotData';

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        countryCode: this.countryCode,
        workshopCode: req.workshopCode,
        fromDate: req.fromDate,
        toDate: req.toDate
      })
    };
    return this.http.get(requestUrl, httpOptions);
  }

  /**
  * Name: getTitanWorkshopBay
  * purpose: To get getTitanWorkshopBay
  * @param {string} userId - userId
  * @return {Observable} response list of titan workshop bay
  */
  getTitanWorkshopBay(userId: string): Observable<object> {
    const requestUrl = this.uri + 'customer360/getTitanWorkshopBay';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        userId: userId
      })
    };
    return this.http.get(requestUrl, httpOptions);
  }
}
